import React, { useState, useEffect } from "react";
import pup from "../assetss/img/popup/wellcome2.jpg";

const PopUp = ({ show, setShow }) => {
  const closePop = () => {
    setShow(false);
    sessionStorage.setItem("popupShown", "true");
  };
  return (
    <>
      {show && (
        <div className="absolute bg-gray-900 bg-opacity-50 top-0 left-0 w-full h-full  z-50 ">
          <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-72  backdrop-filter backdrop-blur-sm rounded-md bg-opacity-50 border bg-white border-gray-100 z-60 flex flex-col justify-around ">
            {/* <p onClick={closePop} className="mr-3 mt-2 cursor-pointer">X</p> */}
            <svg
            onClick={closePop}
            className="mr-3 mt-2 mb-2 cursor-pointer"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.16998 14.83L14.83 9.17004"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.83 14.83L9.16998 9.17004"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <img className="w-11/12 mx-auto h-10/12  rounded-md" src={pup} alt="" />
            <a
              href="https://www.instagram.com/restaurant_kandouk/"
              className="bg-yellow-600 p-3 mb-2 flex justify-center text-xl font-bold mt-2 w-11/12 mx-auto rounded-md"
            >
              ما رو فالو کنید
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default PopUp;
